import { EntityAdapter } from 'vue-entity-adapter'

export const adapter = new EntityAdapter((a, b) => b.answered_at.localeCompare(a.answered_at))

export default adapter
